import axios from 'axios';
import { apiCube, AuthorizationCube } from '../utils/index';
import gql from 'graphql-tag';
import { client } from '../App';

const prefix = 'FILTERS';

export const GET_PORTFOLIOS = `${prefix}_GET_PORTFOLIOS`;
export const GET_PORTFOLIOS_SUCCESS = `${prefix}_GET_PORTFOLIOS_SUCCESS`;
export const GET_PORTFOLIOS_ERROR = `${prefix}_GET_PORTFOLIOS_ERROR`;
export const GET_INDICATORS = `${prefix}_GET_INDICATORS`;
export const GET_INDICATORS_SUCCESS = `${prefix}_GET_INDICATORS_SUCCESS`;
export const GET_INDICATORS_ERROR = `${prefix}_GET_INDICATORS_ERROR`;
export const GET_SERVICES_SUCCESS = `${prefix}_GET_SERVICES_SUCCESS`;
export const GET_SERVICES_ERROR = `${prefix}_GET_SERVICES_ERROR`;
export const SAVE_FILTERS = `${prefix}_SAVE_FILTERS`;
export const SAVE_FILTERS_SUCCESS = `${prefix}_SAVE_FILTERS_SUCCESS`;
export const SAVE_FILTERS_ERROR = `${prefix}_SAVE_FILTERS_ERROR`;
export const SET_FILTERS_SUCCESS = `${prefix}_SET_FILTERS_SUCCESS`;
export const APPLY_FILTERS_SUCCESS = `${prefix}_APPLY_FILTERS_SUCCESS`;
export const GET_FILTERS = `${prefix}_GET_FILTERS`;
export const GET_FILTERS_SUCCESS = `${prefix}_GET_FILTERS_SUCCESS`;
export const GET_FILTERS_ERROR = `${prefix}_GET_FILTERS_ERROR`;

function getPortfoliosSuccess(data) {
  return {
    type: GET_PORTFOLIOS_SUCCESS,
    payload: {
      data
    }
  };
}

function getPortfoliosError(error) {
  return {
    type: GET_PORTFOLIOS_ERROR,
    payload: {
      error
    }
  };
}

function getIndicatorsSuccess(data) {
  return {
    type: GET_INDICATORS_SUCCESS,
    payload: {
      data
    }
  };
}

function getIndicatorsError(error) {
  return {
    type: GET_INDICATORS_ERROR,
    payload: {
      error
    }
  };
}

function getServicesSuccess(data) {
  return {
    type: GET_SERVICES_SUCCESS,
    payload: {
      data
    }
  };
}

function getServicesError(error) {
  return {
    type: GET_SERVICES_ERROR,
    payload: {
      error
    }
  };
}


function saveFiltersSuccess(data) {
  return {
    type: SAVE_FILTERS_SUCCESS,
    payload: {
      data
    }
  };
}

function saveFiltersError(error) {
  return {
    type: SAVE_FILTERS_ERROR,
    payload: {
      error
    }
  };
}

function setFiltersSuccess(data) {
  return {
    type: SET_FILTERS_SUCCESS,
    payload: {
      data
    }
  };
}

function applyFiltersSuccess(data) {
  return {
    type: APPLY_FILTERS_SUCCESS,
    payload: {
      data
    }
  };
}

function getFiltersSuccess(data) {
  return {
    type: GET_FILTERS_SUCCESS,
    payload: {
      data
    }
  };
}

function getFiltersError(error) {
  return {
    type: GET_FILTERS_ERROR,
    payload: {
      error
    }
  };
}

export const gePortfolios = () => {
  return dispatch => {
    client
      .query({
        query: gql`
          { 
            portfolios {
              portfolioId
              name
              year
            }
          }
        `
      })
      .then(results => dispatch(getPortfoliosSuccess(results)))
      .catch(error => dispatch(getPortfoliosError(error)));
  };
};

export const gePortfoliosWithManagers = () => {
  return dispatch => {
    client
      .query({
        query: gql`
          { 
            portfolios {
              portfolioId
              name
              year
              relationshipManager {
                accountId
                firstName
                lastName
              }
            }
          }
        `
      })
      .then(results => dispatch(getPortfoliosSuccess(results)))
      .catch(error => dispatch(getPortfoliosError(error)));
  };
};


const indicatorsQuery = encodeURI(
  JSON.stringify({
    measures: ['Claims.totalClaim'],
    dimensions: ['Indicators.name'],
    filters: [
      {
        dimension: 'Portfolios.status',
        operator: 'equals',
        values: ['Active']
      },
    ]
  })
);

export function getIndicators() {
  if (AuthorizationCube)
    axios.defaults.headers.common.Authorization = AuthorizationCube;
  return dispatch => {
    return axios
      .get(`${apiCube}cubejs-api/v1/load?query=${indicatorsQuery}`)
      .then(response => response.data)
      .then(data => dispatch(getIndicatorsSuccess(data)))
      .catch(error => dispatch(getIndicatorsError(error)));
  };
}

export function saveFilters(form) {
  return dispatch => {
    return axios
      .post('v4/accounts/me/dashboard_templates', form)
      .then(response => response.data)
      .then(data => dispatch(saveFiltersSuccess(data)))
      .catch(error => dispatch(saveFiltersError(error)));
  };
}

export function setFilters(filters) {
  return dispatch => {
    return dispatch(setFiltersSuccess(filters));
  };
}

export function applyFilters(filters) {
  return dispatch => {
    return dispatch(applyFiltersSuccess(filters));
  };
}

export function getFilters(form) {
  return dispatch => {
    return axios
      .get('v4/dashboard-templates', form)
      .then(response => response.data)
      .then(data => dispatch(getFiltersSuccess(data)))
      .catch(error => dispatch(getFiltersError(error)));
  };
}

const servicesQuery = encodeURI(
  JSON.stringify({
    measures: ['Services.count'],
    dimensions: ['Services.name'],
    filters: []
  })
);

export function getServices() {
  if (AuthorizationCube)
    axios.defaults.headers.common.Authorization = AuthorizationCube;
  return dispatch => {
    return axios
      .get(`${apiCube}cubejs-api/v1/load?query=${servicesQuery}`)
      .then(response => response.data)
      .then(data => dispatch(getServicesSuccess(data)))
      .catch(error => dispatch(getServicesError(error)));
  };
}